import React, { useEffect, useState, useRef, useContext } from 'react';
import firebase from "firebase/compat/app";

import IconButton from '@mui/material/IconButton';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import Alert from '@mui/material/Alert'
import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import { styled, keyframes } from '@mui/system';

import { auth, db } from "../firebase.js";
import { AlertContext } from '../AlertContext.js';
import SignOut from './SignOut.js';
import SendMessage from './SendMessage.js';



// 3点リーダー用スタイル定義
const load = keyframes`
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 1em;
  }
  40% {
    box-shadow: 0 -0.5em;
    height: 1.25em;
  }
`;

const Loading = styled('div')({
  color: '#888',
  textIndent: '-9999em',
  margin: '0 auto',
  position: 'relative',
  fontSize: '1em',
  transform: 'translateZ(0)',
  animation: `${load} 1.4s infinite ease-in-out`,
  '&::before': {
    left: '-1.5em',
    animationDelay: '-0.16s',
  },
  '&::after': {
    left: '1.5em',
    animationDelay: '0.16s',
  },
  '&, &::before, &::after': {
    background: '#888',
    width: '0.25em',
    height: '0.75em', // 高さを調整
  },
  '&::before, &::after': {
    position: 'absolute',
    top: '0.125em', // 上部の位置を調整
    content: '""',
  },
});


// alert のスタイルクラス
const StyledAlert = styled(Alert)({
  width: '50%',
  margin: '0 auto',
  marginBottom: '20px',
});


// // Chats コレクションにドキュメントを新規生成し、そのセッションを返す
// const createChatSession = async (adminId) => {
//   const uid = auth.currentUser.uid;
//   const email = auth.currentUser.email;
  
//   console.log("# createNewChatSession() called.");
//   console.log("# uid: ", uid);
//   console.log("# email: ", email);

//   // 新しいチャットセッションドキュメントを追加
//   const chatsSessionRef = await db.collection('Chats').add({
//     adminId: adminId,
//     createdAt: firebase.firestore.FieldValue.serverTimestamp(),
//     participants: email,
//   });
  
//   console.log("# createNewChatSession() end: ", chatsSessionRef);
//   // 生成されたセッションを返す
//   return chatsSessionRef;
// };


const Display = ({ adminId }) => {
  // const [chatsId, setChatsId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [chatsRef, setChatsRef] = useState(null);
  // const [isCreatingSession, setIsCreatingSession] = useState(false);
  const [messages, setMessages] = useState([]);
  const [votes, setVotes] = useState({});
  
  const { timeoutOccurred, isLimited, errorMessage } = useContext(AlertContext);

  let reversedMessages = [...messages].reverse();

  const isCreatingSession = useRef(false);

  // useEffect(() => {
  //   const initiateChatSession = async () => {
  //     if (!chatsRef && !isCreatingSession.current) {
  //       isCreatingSession.current = true;
  //       try {
  //         const newChatsRef = await createChatSession(adminId);
  //         setChatsRef(newChatsRef);
  //       } catch (error) {
  //         console.error("Error creating chat session: ", error);
  //       } finally {
  //         isCreatingSession.current = false;
  //       }
  //     }
  //   };

  //   initiateChatSession();
  // }, [chatsRef, adminId]);

  useEffect(() => {
    if (chatsRef) {
      // Firestoreからメッセージを取得
      const unsubscribe = db.collection("Chats")
        .doc(chatsRef.id)
        .collection("Messages")
        .orderBy("createdAt", "desc")
        .limit(50)
        .onSnapshot((snapshot) => {
          setMessages(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        });

      return () => unsubscribe();
    }
  }, [chatsRef]);


  const handleVote = async (messageId, qualityFlag) => {
    await db.collection('Chats').doc(chatsRef.id).collection('Messages').doc(messageId).update({
      qualityFlag: qualityFlag
    });
    setVotes(prevVotes => ({ ...prevVotes, [messageId]: qualityFlag }));
  };


  if (!chatsRef) {
    // chatsIdが未設定の場合
    return (
      <div>
        <SignOut />
        <div>チャットを開始してください。</div>
        <SendMessage
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setChatsRef={setChatsRef} 
          adminId={adminId}
        />
      </div>
    );
  }

  // メッセージリストとSendMessageコンポーネントの表示
  return (
    <div>
      <SignOut />
      <div className="msgs">
      {reversedMessages.map(({ id, text, photoURL, uid }) => (
        <div key={id}>
          <div className={`msg ${uid === auth.currentUser.uid ? "sent" : "received"}`}>
            <div className="img-container">
              <img src={photoURL} alt="" />
            </div>
            <div>
              {uid !== auth.currentUser.uid && (
                <div className="name-content">
                  <p>チャットボット</p>
                </div>
              )}
              <div className="msg-content">
                <p>{text}</p>
              </div>
              {uid !== auth.currentUser.uid && (
                <div className="vote-question">
                  <span>この回答は役に立ちましたか？</span>
                  <IconButton color="default" aria-label="upvote" onClick={() => handleVote(id, 'good')} fontSize="small">
                    {votes[id] === 'good' ? <ThumbUpIcon /> : <ThumbUpOutlinedIcon />}
                  </IconButton>
                  <IconButton color="default" aria-label="downvote" onClick={() => handleVote(id, 'bad')} fontSize="small">
                    {votes[id] === 'bad' ? <ThumbDownIcon /> : <ThumbDownOutlinedIcon />}
                  </IconButton>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {isLoading && (
        <div className="msg received">
          <div className="img-container">
            <img src="https://cdn.worldvectorlogo.com/logos/openai-2.svg" alt="" />
          </div>
          <div>
            <div className="name-content">
              <p>チャットボット</p>
            </div>
            <div className="msg-content" style={{ height: '1.5em' }}>
              <Loading />
            </div>
          </div>        
        </div>
      )}
      </div>
      {
        timeoutOccurred &&
        <StyledAlert severity="error">
          リクエストがタイムアウトしました。再度試してください。
          {/* <IconButton color="primary" onClick={handleSubmit}>
            <RefreshIcon /> 再試行
          </IconButton> */}
        </StyledAlert>
      }
      {
        isLimited &&
        <StyledAlert severity="warning">
          メッセージの制限に達しました。しばらく待ってから再度お試しください。
        </StyledAlert>
      }
      {errorMessage && 
        <StyledAlert severity="error">
          {errorMessage}
        </StyledAlert>
      }
      <SendMessage 
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        chatsRef={chatsRef} 
        setChatsRef={setChatsRef} 
        adminId={adminId}
      />
    </div>
  );
}

export default Display;
